import React from "react";
import FORTA_data from "../json/FORTA.json";

function FORTA({ drug }) {
  const filteredResults = FORTA_data.filter((row) => {
    const drugName = row["Drug Name "].toLowerCase().trim();
    const targetDrugName = drug.toLowerCase().trim();
    return drugName.startsWith(targetDrugName) || drugName.endsWith(targetDrugName);
  });
  return (
    <div>
      {filteredResults.length > 0 ? (
        filteredResults.map((result, index) => (
          <div className="table-cell" key={index}>
            {drug.trim().length < result["Drug Name "].trim().length && <p>For Drug: {result["Drug Name "]}</p>}
            <div>Condition: {result["Condition "]}</div>
            <div>FORTA Class: {result["FORTA Class"]}</div>
          </div>
        ))
      ) : (
        <p>No results found</p>
      )}
    </div>
  );
}

export default FORTA;
